import styled from "styled-components";
import { useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import {
  resetUserAccountDetails,
  resetNewDashboardInformation,
  setFirstLogin,
} from "../redux/actions";
import { analytics } from "../analytics";
import Cookies from "universal-cookie";
const cookies = new Cookies();

const ButtonWrapper = styled.div`
  position: absolute;
  background-color: white;
  box-shadow: rgba(0, 0, 0, 0.35) 0px 5px 15px;
  padding: 10px 10px;
  right: 50px;
  top: 60px;
  cursor: pointer;
`;

const LogoutButton = ({ userAccountDetails }) => {
  const history = useHistory();
  const dispatch = useDispatch();

  const handleLogoutClick = () => {
    analytics.track("Signed Out", {
      userId: userAccountDetails?.id || "",
    });
    dispatch(resetUserAccountDetails());
    dispatch(resetNewDashboardInformation());
    dispatch(setFirstLogin(true));
    cookies.remove("accessToken");
    history.push("/");
  };

  return (
    <ButtonWrapper>
      <div style={{ fontWeight: "700" }} onClick={handleLogoutClick}>
        Logout
      </div>
    </ButtonWrapper>
  );
};

export default LogoutButton;
